import { render } from "./AttendanceStats.vue?vue&type=template&id=8446abb6"
import script from "./AttendanceStats.vue?vue&type=script&lang=js"
export * from "./AttendanceStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__